export default __webpack_public_path__ + "static/media/white-loading.559bf5a6.png";